import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { MenuItem } from "@mui/material";
import FormSelect from "../../../../../../components/Forms/FormSelect";

function Position({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable={true}
      options={[
        <MenuItem key={"Default"} value={""}>
          Default
        </MenuItem>,
        ["absolute", "relative", "fixed"].map((fontName) => {
          return (
            <MenuItem key={fontName} value={fontName}>
              {fontName}
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSPositionComponent: JSInputComponent = {
  Component: Position,
  handlesCssProperties: ["position"],
};
